module.exports = __webpack_public_path__ + "img/2023-18.1b0255f8.jpg";